// Vuex 4 provides its store using this public injection key. Options API mapped
// state must resolve the nearest scope too (brew displays have independent stores).
export const storeScope = { inject: { $store: { from: 'store', default: undefined } } };
